<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        事業者管理　
        <div class="headerBtn" @click="add">新規登録</div>
      </div>

      <div class="row">
        <p class="inputTitle condition">メールアドレス</p>
        <multiselect
          v-model="loginIdCondition"
          :options="loginIdOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいメールアドレスを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          style="margin: auto"
          @tag="addLoginIdTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="row">
        <p class="inputTitle condition">事業者名</p>
        <multiselect
          v-model="companyNameCondition"
          :options="companyNameOptions"
          :multiple="true"
          :taggable="true"
          label="companyName"
          placeholder="検索したい事業者名を選択"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          track-by="companyId"
          style="margin: auto"
          @tag="addCompanyNameTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="searchBtn" @click="search()">検索</div>

      <!-- 取得ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- APIエラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 削除エラー表示 -->
      <div v-if="deleteErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの削除中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= conditionRow.length">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{conditionRow.length}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{conditionRow.length}} / {{conditionRow.length}} 件
        </div>
      </div>
      <vue-good-table
        :columns='columns'
        :rows='conditionRow'
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          mode: 'pages',
          perPage: 100,
          position: 'top',
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: '次へ',
          prevLabel: '前へ',
          rowsPerPageLabel: '表示する行数',
          ofLabel: '/',
          pageLabel: 'ページ',
          allLabel: 'All',
        }"
        :group-options="{
          enabled: false
        }"
        @on-page-change="onPageChange"
        @on-cell-click="openDetail"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="remove" @click.stop="openDeleteModal(props.formattedRow)">削除</div>
          </span>
        </template>
        <div slot="selected-row-actions">
          <button type="button" class="remove" @click.stop="bulkDelete" style="line-height: 20px;">選択データを削除</button>
        </div>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && conditionRow.length > csvLimit"
        v-bind:class="{
          disabled: !csvDlFlg && conditionRow.length > csvLimit,
          active: csvDlFlg && conditionRow.length <= csvLimit
        }"
      >
        表示中のデータをCSV形式でダウンロード
      </button>
      <div style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>

    <!-- 詳細モーダル画面 -->
    <Modal size="business" @close="closeModal" v-if="detailModal" style="font-weight: bold;">
      <Detail :companyId=selectRow.companyId :name=selectRow.companyName style="padding-left: 0px;" />
      <button @click="closeModal" class="branchChange" style='margin-bottom: 15px;'>閉じる</button>
    </Modal>

    <!-- 事業者所属現場削除確認モーダル画面 -->
    <Modal size="deleteCompanySites" @close="closeDeleteModal" v-if="deleteModal">
      <p class="modalTitle">事業者削除確認</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当に {{selectRow.companyName}} の事業者情報を削除してもよろしいですか？<br>
          事業者に所属する以下の現場情報も削除されます。<br>
        </p>
        <!-- <p v-show="deleteCompanySiteList.length != 0">
          <div v-for="site in deleteCompanySiteList" v-bind:key="site.id">
            ・{{site.siteName}}
          </div>
        </p> -->
        <!-- 取得ローディング -->
        <div v-if="deleteLodingFlg">
          <vue-loading
            type="cylon"
            color="#1b7e47"
            :size="{ width: '150px', height: '150px' }"
          >
          </vue-loading>
          <div style="padding: 0px 0px 30px 0px;">Now deleting...</div>
        </div>
        <vue-good-table
          :columns='deleteCompanySiteColumns'
          :rows='deleteCompanySiteList'
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 5,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
        >
      <div slot="emptystate">データがありません</div>
    </vue-good-table>
      </div>
      <button @click.once="deleteExecution(selectRow.companyId, selectRow.loginId)" class="modalYes">削除する</button>
      <button @click="closeDeleteModal" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>

    <!-- 削除モーダル画面 -->
    <!-- <Modal size="delete" @close="closeDeleteModal" v-if="deleteModal">
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当に【ID： {{selectRow.companyId}} 】の事業者情報を削除してもよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。<br>
          ※この直前に事業者に紐づく現場・技能者の削除確認処理を挟む予定
        </p>
      </div>
      <button @click="deleteExecution(selectRow.companyId)" class="modalYes">削除する</button>
      <button @click="closeDeleteModal" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal> -->
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import Modal from './BaseModal.vue';
import Detail from './BusinessDetail.vue';
import common from '../services/common';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: '事業者一覧',
  name: 'Worker',
  components: {
    VueGoodTable,
    Modal,
    Detail,
    VueLoading,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      detailModal: false,
      deleteModal: false,
      loginIdOptions: [],
      loginIdCondition: [],
      companyNameOptions: [],
      companyNameCondition: [],
      columns: [
        {
          label: '事業者名',
          field: 'companyName',
          sortable: true,
          width: '200px',
        },
        {
          label: 'CCUS事業者ID',
          field: 'ccusCompanyId',
          sortable: true,
          width: '150px',
        },
        {
          label: 'ログインID',
          field: 'loginId',
          sortable: true,
          width: '150px',
        },
        {
          label: 'メールアドレス',
          field: 'email',
          sortable: true,
          width: '150px',
        },
        {
          label: '登録日',
          field: 'createdAt',
          sortable: true,
          // type: 'date',
          // dateInputFormat: 'yyyy-mm-dd',
          // dateOutputFormat: 'yyyy年mm月dd日',
          width: '130px',
          formatFn: this.callDateFormat,
        },
        {
          label: '内部ID',
          field: 'companyId',
          sortable: true,
          width: '160px',
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          width: '65px',
        },
      ],
      rows: [],
      conditionRow: [],
      selectRow: [],
      deleteCompanySiteList: [],
      deleteCompanySiteColumns: [
        {
          label: '現場名',
          field: 'siteName',
        },
      ],
      // ローディング
      getLodingFlg: false,    // データ取得時ローディング用フラグ
      getErrorFlg: false,     // データ取得時エラーフラグ
      deleteLodingFlg: false, // データ削除時ローディングフラグ
      deleteErrorFlg: false,  // データ削除時エラーフラグ
      csvDlFlg: false,
      errorMessage: '',
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // CSV取得上限
      csvLimit: 10000,
    };
  },
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // 事業者一覧取得
      this.rows = await this.callGetCompaniesList();
      // 初期データをセット
      this.conditionRow = this.rows;
      // 事業者リスト取得
      this.companyNameOptions = await this.callGetCompaniesNameList();
      // URL検索条件確認
      this.loginIdCondition = common.getUrlParam('loginId', 0);
      this.companyNameCondition = common.getUrlParam('companyName', 0);
      // 検索処理呼出
      this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 事業者一覧取得API呼び出し
    async callGetCompaniesList() {
      try {
        const restResourceService = new ApiClient();
        const resultRows = await restResourceService.getCompaniesList();
        // エポックミリ秒をYYYY-MM-DDに変換
        resultRows.forEach((resultRow, index) => {
          resultRows[index].createdAt = common.dateFormatHyphen(resultRow.createdAt);
        });
        this.csvDlFlg  = (resultRows.length > 0) ? true : false;
        return resultRows;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 日時値を年月日（YYYY年MM月DD日）に変換
    callDateFormat(value) {
      return common.dateFormat(value);
    },
    // 事業者名リスト取得API呼び出し
    async callGetCompaniesNameList() {
      try {
        switch (this.role) {
          case 'admin':
            const restResourceService = new ApiClient();
            return await restResourceService.getCompaniesNameList();
            break;
          case 'business':
            break;
          case 'branch':
            break;
          case 'worker':
            break;
          default:
            break;
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 検索条件：メールアドレス追加
    addLoginIdTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };

      this.loginIdCondition.push(tag);
      this.loginIdOptions.push(tag);
    },
    // 検索条件：事業者名追加
    addCompanyNameTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.companyNameCondition.push(tag);
      this.companyNameOptions.push(tag);
    },
    // 検索ボタン押下時
    search() {
      this.setCondition(this.rows);
      // 検索条件をURLに詰める
      common.setUrlParam('loginId', this.loginIdCondition, 0);
      common.setUrlParam('companyName', this.companyNameCondition, 0);
      // テーブルが空の場合CSVダウンロードを非活性
      this.csvDlFlg  = (this.conditionRow.length > 0) ? true : false;
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition(rows) {
      if (this.loginIdCondition.length === 0 && this.companyNameCondition.length === 0) {
        // 検索条件がない場合、初期データを書き戻す
        this.conditionRow = rows;
        return;
      }
      let newRows = [];
      let tempRows = rows;
      this.conditionRow = [];
      // 検索条件：メールアドレス(部分一致)
      if (this.loginIdCondition.length !== 0) {
        newRows = [];
        // 検索用タグ配列分ループ
        this.loginIdCondition.forEach(
          (loginId) => {
            // 表示中のテーブル列の中からタグ
            const tempRow = tempRows.filter((v) =>
              v.email.match(loginId.name),
            );
            if (tempRow.length !== 0) {
              Array.prototype.push.apply(newRows, tempRow);
            }
          },
        );
        // 重複チェック
        this.conditionRow = Array.from(
          new Map(newRows.map((row) => [row.companyId, row])).values()
        );
        tempRows = this.conditionRow;
      }
      // 検索条件：事業者名（選択）
      if (this.companyNameCondition.length !== 0) {
        // 検索条件に合うレコードを取得
        this.conditionRow = common.searchConditionName(this.companyNameCondition, tempRows, 'companyName');
        tempRows = this.conditionRow;
      }
    },
    // 事業者新規登録画面へ遷移
    add() {
      this.$router.push('/business/add');
    },
    // 事業者-詳細画面 or 詳細モーダルを開く
    openDetail(params) {
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.closeModal);
      this.selectRow = params.row;
      // モーダル表示
      this.detailModal = true;
    },
    // 詳細モーダルを閉じる
    closeModal() {
      window.removeEventListener('popstate', this.closeModal);
      this.detailModal = false;
    },
    // 削除モーダルを開く
    async openDeleteModal(params) {
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.closeDeleteModal);
      // 事業者所属現場リストを検索
      const companyId = params.companyId;
      const restResourceService = new ApiClient();
      this.deleteCompanySiteList = await restResourceService.getCompaniesSiteList(companyId);
      this.selectRow = params;
      this.deleteModal = true;
    },
    // 削除モーダルを閉じる
    closeDeleteModal() {
      window.removeEventListener('popstate', this.closeDeleteModal);
      this.deleteModal = false;
    },
    // 削除実行
    async deleteExecution(companyId, loginId) {
      try {
        this.deleteErrorFlg = false;
        this.deleteLodingFlg = true;
        const restResourceService = new ApiClient();
        // 事業者削除API呼び出し
        const result = await restResourceService.deleteCompany(companyId);
        // cognitoユーザー削除
        await this.$cognito.deleteUsers([loginId]);
        // 事業者に紐づく事業者がある場合 congitoユーザを削除する
        console.log(result['companyGroups'].length !== 0)
        if(result['companyGroups'].length !== 0){
          for(const id of result['companyGroups']) {
            await this.$cognito.deleteUsers([id]);
          }
        }
        // 事業者一覧再取得
        this.rows = await this.callGetCompaniesList();
        // 初期データをセット
        this.conditionRow = this.rows;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.deleteErrorFlg = true;
      } finally {
        this.deleteModal = false;
        this.deleteLodingFlg = false;
      }
    },
    // アクセスログ
    accessLog() {
      this.$router.push({
        name: 'AccessLog',
        params: {
          id: this.id,
        },
      });
    },
    // ログイン履歴
    loginLog() {
      this.$router.push({
        name: 'LoginLog',
        params: {
          id: this.id,
        },
      });
    },
    // CCUSID修正
    ccusIdChange() {

    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      const columns = this.columns;
      // 参照元更新回避
      const rows = JSON.parse(JSON.stringify(this.conditionRow));
      console.log("rows:", this.conditionRow);
      rows.forEach((row, index) => {
        if (row.createdAt) {
          rows[index].createdAt = common.dateFormat(row.createdAt);
        }
      });
      // ファイル名用の現在日時
      const currentDate = new Date().getTime();
      const date = await common.getToday(currentDate);
      const fileName = '事業者一覧'+date;
      common.outputCsv(columns, rows, fileName);
    },
    // 現在ページ更新
    onPageChange(params) {
      this.currentPage = params.currentPage;
      common.scrollTop();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
